import React from "react";
import PropTypes from "prop-types";
import { IMaskInput } from "react-imask";
import Loader from "../Loader";

const Form = ({ handleSubmit, onInputChange, isLoading, form }) => {
  const isValid = /^\+1 \(\d{3}\) \d{3}-\d{4}$/.test(form.phone);
  const handleBlur = () => {
    if (!isValid) {
      onInputChange({ target: { name: "phone", value: "" } });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-semibold text-gray-800">Nom</label>
        <input
          value={form.firstName}
          type="text"
          name="firstName"
          onChange={onInputChange}
          required
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder=""
          disabled={isLoading}
        />
      </div>
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-semibold text-gray-800">
          Nom de famille
        </label>
        <input
          value={form.lastName}
          type="text"
          name="lastName"
          onChange={onInputChange}
          required
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder=""
          disabled={isLoading}
        />
      </div>
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-semibold text-gray-800">
          Téléphone
        </label>
        <IMaskInput
          name="phone"
          type="tel"
          mask="+1 (000) 000-0000"
          value={form.phone}
          unmask={false}
          onAccept={(val) =>
            onInputChange({ target: { name: "phone", value: val } })
          }
          onBlur={handleBlur}
          placeholder="+1 (123) 456-7890"
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />
      </div>
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-semibold text-gray-800">
          Adresse email
        </label>
        <input
          value={form.email}
          type="email"
          name="email"
          onChange={onInputChange}
          required
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder=""
          disabled={isLoading}
        />
      </div>
      <div className="flex flex-col space-y-1">
        <div className="flex items-start">
          <input
            checked={form.emailNotifications}
            id="emailNotifications"
            name="emailNotifications"
            type="checkbox"
            onChange={onInputChange}
            className="w-4 h-4 mt-0.5 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
          />
          <label
            htmlFor="emailNotifications"
            className="ms-2 text-sm text-gray-900 font-semibold"
          >
            Recevez des mises à jour occasionnelles par e-mail.
          </label>
        </div>
        <div className="flex items-start">
          <input
            checked={form.smsNotifications}
            id="smsNotifications"
            name="smsNotifications"
            type="checkbox"
            onChange={onInputChange}
            className="w-4 h-4 mt-0.5 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
          />
          <label
            htmlFor="smsNotifications"
            className="ms-2 text-sm text-gray-900 font-semibold"
          >
            Envoyez-moi des alertes occasionnelles par SMS.
          </label>
        </div>
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className={`w-full flex items-center space-x-2 justify-center mt-2 px-4 py-2 bg-blue-600 text-white font-semibold text-lg rounded-md hover:bg-blue-700 transition duration-200 uppercase disabled:opacity-70 disabled:cursor-wait`}
      >
        <span>Je confirme que j'habite à Sutton</span>
        {isLoading ? <Loader /> : ""}
      </button>
    </form>
  );
};

Form.propTypes = {
  handleFileChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  onNameChange: PropTypes.func,
};

export default Form;
